var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02479 7C6.74495 7 7.32875 6.3732 7.32875 5.6C7.32875 4.8268 6.74495 4.2 6.02479 4.2C5.30464 4.2 4.72084 4.8268 4.72084 5.6C4.72084 6.3732 5.30464 7 6.02479 7Z",
    fill: "#004FC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02479 0C3.15609 0 0.808963 2.52 0.808963 5.6C0.808963 8.68 3.15609 11.2 6.02479 11.2C8.8935 11.2 11.2406 8.68 11.2406 5.6C11.2406 2.52 8.8935 0 6.02479 0ZM6.02479 0.7C6.35078 0.7 6.67677 1.05 6.67677 1.4C6.67677 1.75 6.35078 2.1 6.02479 2.1C5.63361 2.1 5.37281 1.82 5.37281 1.4C5.37281 0.98 5.63361 0.7 6.02479 0.7ZM6.02479 8.4C4.59044 8.4 3.41688 7.14 3.41688 5.6C3.41688 4.06 4.59044 2.8 6.02479 2.8C7.45915 2.8 8.63271 4.06 8.63271 5.6C8.63271 7.14 7.45915 8.4 6.02479 8.4Z",
    fill: "#004FC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.371 14H0.678567C0.156984 14 -0.169005 13.37 0.0917862 12.95L1.39574 10.57C2.56931 11.83 4.19925 12.6 5.95959 12.6C7.71994 12.6 9.34988 11.83 10.5234 10.57L11.8274 12.95C12.2186 13.37 11.8926 14 11.371 14Z",
    fill: "#004FC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoChat);
export default __webpack_public_path__ + "static/media/VideoChat.501a0b3918ac77acc6651b9032cff4bf.svg";
export { ForwardRef as ReactComponent };